module.exports = __webpack_public_path__ + "img/leakage-detector-lg.932cd818.svg";